<template>
    <el-dialog
        v-drag
        class="record-dialog"
        title="零担自营线路审批记录"
        :visible.sync="visible"
        :close-on-click-modal="false"
        width="900px"
        :before-close="close">
        <el-table :data="tableData" v-loading="loading" border style="width: 100%" max-height="500px">
            <el-table-column show-overflow-tooltip prop="fdUrl" label="流程链接">
                <template slot-scope="{ row }">
                    <a :href="row.fdUrl" target="_blank">{{ row.fdUrl }}</a>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="auditStatus_" label="审批状态" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="createUserName" label="起草人" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="createTime" label="流程创建时间" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="auditTime" label="流程审批时间" width="180"></el-table-column>
        </el-table>
        <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" :loading="btnLoading" @click="close">关闭</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { approvalRecord } from '../../../../../../api/regularRoute.js'
import { dictWithUrl } from '@/components/lots/api'
export default {
    data() {
        return {
            visible: false,
            btnLoading: false,
            loading: false,
            tableData: [],
            pageNo: 1,
            pageSize: 10,
            total: 0,
            commonRouteId: '',
            dict: {},
        }
    },
    computed: {
        isSupplier() {
            return !!this.$store.state.supplier;
        }
    },
    created() {},
    methods: {
        handleCurrentChange(v) {
            this.pageNo = v
            this.getList()
        },
        handleSizeChange(v) {
            this.pageSize = v
            this.pageNo = 1
            this.getList()
        },
        getList() {
            this.loading = true
            approvalRecord({
                commonRouteId: this.commonRouteId,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                orderBy: 'create_time',
                orderByType: 'desc',
            })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.total = res.data.totalCount || 0
                        this.tableData = (res.data.list || []).map(v => {
                            return {
                                ...v,
                                auditStatus_: this.dict['SRM_AUDIT_STATUS'][v.auditStatus],
                                fdUrl: this.isSupplier ? `${location.href.replace('basicInfo', 'mipIframe')}?processId=${this.getParams(v.fdUrl, 'processId')}&routeIds=${this.getParams(v.fdUrl, 'routeIds')}` : v.fdUrl,
                            }
                        })
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        getParams(url, key) {
            if(!url) return 
            const urlParams = new URLSearchParams(url.split('?')[1]);
            const param = urlParams.get(key);
            return param;
        },
        open(commonRouteId) {
            this.visible = true
            this.commonRouteId = commonRouteId
            this.getList()
        },
        close() {
            this.pageNo = 1
            this.pageSize = 10
            this.tableData = []
            this.visible = false
        },
    },
    mounted() {
        dictWithUrl('SRM_AUDIT_STATUS').then(res => {
            this.dict = res.data
        })
    },
}
</script>
<style lang="less" scoped>
.pagination {
    text-align: right;
    margin-top: 10px;
}
</style>
